export default function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/src/event.js
// module id = 1723
// module chunks = 0